import axios from 'axios';
import { renderToString } from 'react-dom/server';
import EmailTemplate from './emailTemplate';
import SurveyEmailTemplate from './SurveyEmailTemplate';
import DashboardEmailTemplate from './DashboardEmailTemplate';


const api = axios.create({
  baseURL:window._env_?.REACT_APP_API_BASE_URL,
  //baseURL:process.env.REACT_APP_API_BASE_URL,
  //baseURL:'http://127.0.0.1:5050/api'
});
/*
export const fetchData = async (endpoint) => {
  try {
    const response = await api.get(`/${endpoint}`);
    console.log(`Fetched from /${endpoint}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${endpoint}:`, error);
    throw error;
  }
};
*/
export const fetchData = async (endpoint, token) => {
  try {
    const headers = {};
    if (token) {
      headers.Authorization = `Bearer ${token}`;
    }
    const response = await api.get(`/${endpoint}`, { headers });
    return response.data;
  } catch (error) {
    console.error(`Error fetching ${endpoint}:`, error);
    throw error;
  }
};



export const postData = async (endpoint, data, token) => {
  try {
    const response = await api.post(`/${endpoint}`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(`Posted to /${endpoint}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error posting to ${endpoint}:`, error.response?.data || error.message);
    throw error;
  }
};


// DELETE request with optional Bearer token
export const deleteData = async (endpoint, data, token) => {
  try {
    const response = await api.delete(`/${endpoint}`, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      data: data, // Body payload
    });
    console.log(`Deleted from /${endpoint}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error deleting from ${endpoint}:`, error.response?.data || error.message);
    throw error;
  }
};

//For update API
export const putData = async (endpoint, data, token) => {
  try {
    const response = await api.put(`/${endpoint}`, data, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
    });
    console.log(`PUT to /${endpoint}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error putting to ${endpoint}:`, error.response?.data || error.message);
    throw error;
  }
};

//For sending an email
export const sendEmail = async (
  endpoint,
  customerName,
  surveyLink='',
  surveyType='',
  projectName='',
  send_to,
  subject,
  token,
  templateType = 'Default',
  role = '',
  appLink = '',
  teamName = '',
  organizationName = 'CriticalRiver Technologies',
  surveyName = '' // Added surveyName parameter for ClientSurvey
) => {
  const htmlBody = EmailTemplate({
    receipientName: customerName,
    surveyLink,
    surveyType,
    projectName,
    organizationName,
    templateType,
    role,
    appLink,
    teamName,
    surveyName // Pass surveyName to EmailTemplate
  });

  try {
    const response = await api.post(`/${endpoint}`, {
      to: send_to,
      subject: subject,
      html: htmlBody,
    }, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    console.log(`Email sent to ${send_to}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error sending email to ${send_to}:`, error.response?.data || error.message);
    throw error;
  }
};

const sendSurveyEmail = async (endpoint, send_to, surveyName, surveyLink, token) => {
  const { subject, html } = SurveyEmailTemplate({ surveyName, surveyLink });

  const response = await api.post(`/${endpoint}`, {
    to: send_to,
    subject,
    html,
  }, {
    headers: {
      'Content-Type': 'application/json',
      Authorization: `Bearer ${token}`,
    },
    withCredentials: true,
  });

  return response.data;
};

export const getBlobAssetUrl = (filename) => {
  const baseUrl = window._env_?.REACT_APP_ASSETSBASE_URL;
  if (!baseUrl) {
    console.warn('Azure Blob Asset base URL is not defined!');
    return '';
  }
  return `${baseUrl}${filename}`;
};

export const uploadProfileImage = async (data) => {
  try {
    const response = await api.post('/uploadimage', data, {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
    });
    console.log('Profile image uploaded:', response.data);
    return response.data;
  } catch (error) {
    console.error('Error uploading profile image:', error.response?.data || error.message);
    throw error;
  }
};

export const sendDashboardEmail = async (
  recipientName,
  surveyType,
  dashboardImage,
  organizationName,
  dashboardTitle,
  send_to,
  subject,
  token,
  attachment, // PDF data as attachment
) => {
  console.log('sendDashboardEmail called with:', { send_to, subject, token });
  const htmlBody = renderToString(
    <DashboardEmailTemplate
      recipientName={recipientName}
      surveyType={surveyType}
      dashboardImage={dashboardImage}
      organizationName={organizationName}
      dashboardTitle={dashboardTitle}
    />
  );
  console.log('Rendered HTML (first 100 chars):', htmlBody.substring(0, 100));

  try {
    const response = await api.post('/send_dashboard_email', {
      to: send_to,
      subject: subject,
      html: htmlBody,
      attachment, // Send the PDF data directly
    }, {
      headers: {
        'Content-Type': 'application/json',
        Authorization: `Bearer ${token}`,
      },
      withCredentials: true,
    });

    console.log(`Dashboard email sent to ${send_to}:`, response.data);
    return response.data;
  } catch (error) {
    console.error(`Error sending dashboard email to ${send_to}:`, error.response?.data || error.message);
    throw error;
  }
};
const apiService = {
  fetchData,
  postData,
  deleteData,
  putData,
  sendEmail,
  getBlobAssetUrl,
  uploadProfileImage,
  sendDashboardEmail,
  sendSurveyEmail
};

export default apiService;


